<template>
  <div class="rm-screen">
    <div v-if="!hasCompanies" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-domain</v-icon>
      {{ $t("no_companies_selected") }}
    </div>
    <div v-else-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!hasData" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-view-grid-plus-outline</v-icon>
      {{ $t("no_data_available") }}
    </div>

    <template v-else>
      <div class="rm-stats rm-stats--pair">
        <div class="rm-stat rm-stat--inverse">
          <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
          <span class="rm-stat__value rm-num">{{ mealTotal }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("report_group.categories") }}</span>
          <span class="rm-stat__value rm-num">{{ shownCategories.length }}</span>
        </div>
      </div>

      <div class="rm-chip-row gm-chips">
        <button
          type="button"
          class="rm-chip"
          :class="{ 'rm-chip--accent': shownCategories.length < mealCategories.length }"
          aria-haspopup="dialog"
          @click="categorySheet = true"
        >
          {{ $t("report_group.categories") }}
          <span class="rm-num">{{ shownCategories.length }}/{{ mealCategories.length }}</span>
          <v-icon size="16" color="#5f5852">mdi-chevron-down</v-icon>
        </button>
      </div>

      <div v-if="!shownCategories.length" class="rm-empty">{{ $t("report_group.no_categories") }}</div>
      <div v-else-if="!days.length" class="rm-empty">
        <v-icon size="40" color="#8a817a">mdi-view-grid-plus-outline</v-icon>
        {{ $t("no_data_available") }}
      </div>
      <template v-else>
        <section v-for="day in days" :key="day.key" class="rm-card rm-mcard">
          <div class="rm-mcard__head gm-day">
            <span class="rm-mcard__title">
              <span class="rm-mcard__name">{{ day.label }}</span>
            </span>
            <span class="rm-mcard__value rm-num">{{ day.total }}</span>
          </div>
          <ul class="rm-list rm-mcard__list">
            <li v-for="row in day.rows" :key="row.key" class="rm-mrow">
              <div class="rm-mrow__main">
                <span class="rm-mrow__name">{{ row.name }}</span>
                <span class="rm-mrow__value rm-num">{{ row.total }}</span>
              </div>
              <div class="rm-mrow__shifts">
                <span v-for="shift in row.shifts" :key="shift.id" class="rm-mrow__shift rm-num">
                  <report-shift-tag :shift="shift.id"></report-shift-tag>
                  {{ shift.quantity }}
                </span>
              </div>
            </li>
          </ul>
        </section>
      </template>
    </template>

    <!-- Podaci za štampu i Excel (stari tab ih čita preko ref-a); bez prikaza -->
    <slot></slot>

    <v-bottom-sheet v-model="categorySheet" max-width="600">
      <section class="rm-theme rm-sheet" :aria-label="$t('report_group.categories')">
        <div class="rm-sheet__body">
          <div class="rm-sheet__handle"></div>
          <div class="rm-sheet__header">
            <h2>{{ $t("report_group.categories") }}</h2>
            <button type="button" class="rm-text-btn" @click="$emit('input', [...mealCategories])">
              {{ $t("report_mobile.all") }}
            </button>
          </div>
          <div class="rm-filter-companies">
            <label v-for="item in categoryItems" :key="item.value" class="rm-filter-company">
              <input type="checkbox" :checked="value.includes(item.value)" @change="toggleCategory(item.value)" />
              {{ item.text }}
            </label>
          </div>
        </div>
        <div class="rm-sheet__footer">
          <button type="button" class="rm-btn rm-btn--primary" @click="categorySheet = false">
            {{ $t("report_desktop.done") }}
          </button>
        </div>
      </section>
    </v-bottom-sheet>
  </div>
</template>

<script>
import ReportShiftTag from "../../../shared/ReportShiftTag.vue";
import "../reportMobileMealCards.scss";

/**
 * Prikaz "Grupe jela" na telefonu (kartica po danu + izbor grupa jela u donjoj kartici). Samo prikazuje; podatke
 * (days) i izbor grupa (v-model) daje ekran koji ga koristi, a u slot stavlja nevidljivu tabelu za štampu i Excel.
 */
export default {
  name: "GroupMobileGroupedView",
  components: { ReportShiftTag },
  props: {
    hasCompanies: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    hasData: { type: Boolean, default: false },
    /** [{ key, label, total, rows: [{ key, name, total, shifts: [{ id, quantity }] }] }] */
    days: { type: Array, default: () => [] },
    mealTotal: { type: Number, default: 0 },
    /** Sve grupe jela i izabrane (ID-jevi) */
    mealCategories: { type: Array, default: () => [] },
    shownCategories: { type: Array, default: () => [] },
    /** [{ value, text }] */
    categoryItems: { type: Array, default: () => [] },
    /** Izabrane grupe jela (v-model) */
    value: { type: Array, default: () => [] },
  },
  data: () => ({
    categorySheet: false,
  }),
  methods: {
    toggleCategory(id) {
      this.$emit("input", this.value.includes(id) ? this.value.filter((item) => item !== id) : [...this.value, id]);
    },
  },
};
</script>

<style lang="scss">
.rm-theme .rm-mcard__head.gm-day {
  cursor: default;
}
</style>
